import instance from './instance';
import { PopularSearchKeywordsResponse } from '../../@types/response-mkm';

export async function getPopularSearchKeywords() {
  const response = await instance.get<PopularSearchKeywordsResponse>('/search/recommend');

  return response.data;
}
